import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '@app/core/business/user/user';
import { UserPreferences } from '../business/user/user-preferences';
import { tap } from 'rxjs/operators';
import { Company } from '../business/company/company';
import { DownloadableDocument } from '../business/downloadable-document';
import { AvailabilityConfiguration } from './app-configuration.service';

@Injectable()
export class ApiService {
    private baseUrl: string = environment.baseApiUrl;
    constructor(private http: HttpClient) { }


    // USERS
    public getUser$(userCode: string): Observable<User> {
        return this.http.get<User>(`${this.baseUrl}/users/${userCode}`);
    }

    public getUsers$(): Observable<User[]> {
        return this.http.get<User[]>(`${this.baseUrl}/users/LightWeight`);
    }

    public putPreferences$(
        userCode: string,
        userPreferences: UserPreferences
    ): Observable<any> {
        return this.http.put(
            `${this.baseUrl}/users/${userCode}/preferences`,
            userPreferences
        );
    }

    public putPassword$(
        userCode: string,
        currentPassword: string,
        newPassword: string,
        repeatNewPassword: string
    ): Observable<any> {
        return this.http.put(`${this.baseUrl}/users/${userCode}/password`, {
            currentPassword: currentPassword,
            newPassword: newPassword,
            repeatNewPassword: repeatNewPassword,
        });
    }


    public switchUser(userCode: string): Observable<any> {
        return this.http
            .post(`${environment.baseApiUrl}/Authentication/SwitchUser`, {
                userName: userCode
            })
    }



    // COMPANIES


    /**
     * Get a company's data from userCode
     * @param userCode Code of the user
     */
    public getCompanies(userCode?: string): Observable<Company[]> {
        const params = new HttpParams({
            fromObject: {
                userCode: userCode,
            },
        });
        return userCode ? this.http.get<Company[]>(`${this.baseUrl}/companies`, {
            params: params,
        }) : this.http.get<Company[]>(`${this.baseUrl}/companies`);
    }

    /**
     * Get a company's CGV
     * @param companyCode Code of the company
     */
    public GetDocumentsCGV(companyCode: string): Observable<Blob> {
        return this.http.get(`${this.baseUrl}/companies/${companyCode}/DocumentsCGV`, {
            responseType: 'blob'
        });
    }


    /**
     * Get a company from its code
     * @param companyCode Code of the company
     */
    public getCompany(companyCode: string): Observable<Company> {
        return this.http.get<Company>(`${this.baseUrl}/companies/${companyCode}`);
    }


    /**
     * Get a company's marketing documents
     * @param companyCode Code of the company
     */
    public getDocumentsFromCompanyCode(companyCode: string, aideALaVente = false): Observable<DownloadableDocument[]> {
        return this.http.get<DownloadableDocument[]>(
            `${this.baseUrl}/companies/${companyCode}/documents?seulementAideALAVente=${aideALaVente}`
        );
    }

    /**
     * Get the availability configuration from the server
     */
    public getConfigurationAvailability(): Observable<AvailabilityConfiguration> {
        return this.http.get<AvailabilityConfiguration>(
            `${this.baseUrl}/configuration/availability`
        );
    }

}

